var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2",attrs:{"id":"theMainTableFixerInvestments"}},[_c('div',{ref:"table",staticClass:"tabulator registrar-table",staticStyle:{"width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }